

import getDisplayBytes from '@shootsta/get-display-bytes';
import copy from 'copy-to-clipboard';
import React, { memo, useEffect, useState } from 'react';
import ICON_MAP from '../../../common/constants/fileTypeIconMap';
import { getTypeFromAsset } from '../../../common/utils';
import { Icon, Image, Text, ToolTip } from '../../../ui-kit';
import { transformFilename } from '../utils';
import '../styles/_manage-asset-modal.scss';

const IMAGE_SIZE = '50px';

const DELETE_KEYS = ['type', 'size', 'bynderAssetId'];

const COPIED_RESET_MS = 2000;





function renderMetaData(metadata) {
  return Object.entries(metadata).
  map((metadataEntry) => {
    const key = metadataEntry[0];
    const value = metadataEntry[1];

    return !DELETE_KEYS.includes(key) && typeof value === 'string' ?

    <Text label key={key}>
            {`${key}: ${value}`}
          </Text> :

    null;
  }).
  filter(Boolean);
}

function getMetadataObject(metaData) {
  try {
    return JSON.parse(metaData);
  } catch (e) {
    return {};
  }
}

function FileInfo(asset) {
  const { metaData: jsonMetadata, filename } = asset;
  const fileType = getTypeFromAsset(asset);
  const icon = ICON_MAP[fileType];
  const metaData = getMetadataObject(jsonMetadata);
  const [copied, setCopied] = useState(false);

  // Display a shortened name in-line, but keep the full filename for the
  // tooltip and the copy action so users can read/copy the original name.
  const displayName = transformFilename(filename);
  const canCopy = Boolean(filename) && filename !== 'N/A';

  useEffect(() => {
    if (!copied) {
      return void 0;
    }

    const timeout = setTimeout(() => setCopied(false), COPIED_RESET_MS);
    // useEffect does not allow us to return null, so we mix returning undefined/function
    // eslint-disable-next-line consistent-return
    return () => clearTimeout(timeout);
  }, [copied]);

  const handleCopy = () => {
    if (!canCopy) {
      return;
    }

    copy(filename);
    setCopied(true);
  };

  const onKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleCopy();
    }
  };

  return (
    <div className="manage-asset-modal__asset-info">
      <div className="manage-asset-modal__asset-info__title">
        <Image
          width={IMAGE_SIZE}
          height={IMAGE_SIZE}
          size={IMAGE_SIZE}
          defaultIconColour="michael"
          defaultImageIcon={icon} />

        <ToolTip
          id={`file-info-filename-${filename}`}
          label={filename}
          place="top"
          className="manage-asset-modal__filename-tooltip">

          <span
            className="manage-asset-modal__asset-info__title__filename-wrapper"
            onClick={handleCopy}
            onKeyDown={onKeyDown}
            role={canCopy ? 'button' : void 0}
            tabIndex={canCopy ? 0 : void 0}>

            <Text heading5 className="manage-asset-modal__asset-info__title__filename">{displayName}</Text>
            {canCopy &&
            <Icon
              name={copied ? 'success' : 'duplicate'}
              size={16}
              color={copied ? 'greenSnake' : 'regent'}
              className="manage-asset-modal__asset-info__title__copy-icon" />}

          </span>
        </ToolTip>
      </div>
      <div className="manage-asset-modal__asset-info__metadata">
        {
        metaData.size || metaData.type ?

        <div className="manage-asset-modal__asset-info__metadata__main">
                <Text label>{metaData.type && `File type: ${metaData.type}`}</Text>
                <Text label>{metaData.size && `${getDisplayBytes(metaData.size)}`}</Text>
              </div> :

        null}

        {renderMetaData(metaData)}
      </div>
    </div>);

}

export default memo(FileInfo);
